
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole" [ngClass]="{'general-disabled':isMigrationActive}">
  <user-selection #userSelection [pageSize]="5" [projectId]="workflowTargetInfo.projectId" [disableAll]="isLocked"></user-selection>
</div>